var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import React, { useCallback, useEffect, useMemo, useRef, useState } from "react";
import axios from "axios";
import { extractApiErrorMessage } from "../../http/extractApiErrorMessage";
import { Card } from "../card";
import { useCreditPaymentContext } from "./CreditPaymentContext";
import { PaymentErrorNotice } from "./PaymentErrorNotice";
import { useCart, useOrderIntent } from "../../providers";
import { createVantivVerificationGate, parseVantivCompletionEvent } from "./VantivHostedPaymentState";
// FIS recommends polling no more often than every five seconds and prefers ten.
var VERIFY_RETRY_LIMIT = 6;
var VERIFY_INTERVAL_MS = 10000;
var getCartTipAmount = function (cart) {
    var tipAmount = cart === null || cart === void 0 ? void 0 : cart.delivery_tip;
    if (typeof tipAmount === "number" || typeof tipAmount === "string") {
        return tipAmount;
    }
    return undefined;
};
export var VantivHostedPaymentForm = function () {
    var _a, _b, _c;
    var _d = useCreditPaymentContext(), processorInfo = _d.processorInfo, handleCreditOrderComplete = _d.handleCreditOrderComplete, reportProcessorError = _d.reportProcessorError, paymentError = _d.paymentError, clearPaymentError = _d.clearPaymentError, markPaymentSubmitting = _d.markPaymentSubmitting, refreshCart = _d.refreshCart, refreshVantivProcessorInfo = _d.refreshVantivProcessorInfo, checkoutUserId = _d.checkoutUserId, checkoutComment = _d.checkoutComment, isCurbsideOrder = _d.isCurbsideOrder, shouldSendSmsAlerts = _d.shouldSendSmsAlerts, hasMarketingOptIn = _d.hasMarketingOptIn, smsNumber = _d.smsNumber, signUpRewards = _d.signUpRewards;
    var _e = useState(function () { return window.innerWidth <= 768; }), isMobile = _e[0], setIsMobile = _e[1];
    var _f = useState(false), pendingPayment = _f[0], setPendingPayment = _f[1];
    var _g = useState(false), finalizedPayment = _g[0], setFinalizedPayment = _g[1];
    var _h = useState(false), timeoutActive = _h[0], setTimeoutActive = _h[1];
    var _j = useState(0), iframeResetKey = _j[0], setIframeResetKey = _j[1];
    var _k = useState(null), iframeSrc = _k[0], setIframeSrc = _k[1];
    // Once supplied by the completion callback, this immutable ID—not a later
    // processor refresh—is the payment that verification must target.
    var _l = useState(null), submittedPaymentId = _l[0], setSubmittedPaymentId = _l[1];
    var _m = useCart(), currentCart = _m.cart, cartRevision = _m.cartRevision;
    var previousCartRevisionRef = useRef(null);
    var retryTimeoutRef = useRef(null);
    var resetIframeTimeoutRef = useRef(null);
    var verificationGateRef = useRef(createVantivVerificationGate(VERIFY_RETRY_LIMIT));
    var verifyPaymentRef = useRef(function () { return __awaiter(void 0, void 0, void 0, function () { return __generator(this, function (_a) {
        return [2 /*return*/, undefined];
    }); }); });
    var iframeRef = useRef(null);
    var transactionInfo = ((_a = processorInfo === null || processorInfo === void 0 ? void 0 : processorInfo.transactionInfo) !== null && _a !== void 0 ? _a : {});
    var requestInfo = ((_b = transactionInfo.Request) !== null && _b !== void 0 ? _b : {});
    var usesZeroAuth = transactionInfo.zeroAuth === true;
    var currentAddress = useOrderIntent().currentAddress;
    var rewardsSignupPayload = signUpRewards ? { sign_up_rewards: true } : {};
    var iframeUrl = useMemo(function () {
        var _a, _b, _c;
        var desktopUrl = String((_a = transactionInfo.iFrameUrl) !== null && _a !== void 0 ? _a : "");
        var mobileUrl = String((_b = transactionInfo.iFrameUrlMobile) !== null && _b !== void 0 ? _b : "");
        var paymentId = String((_c = requestInfo.PaymentID) !== null && _c !== void 0 ? _c : "");
        var baseUrl = isMobile ? mobileUrl : desktopUrl;
        if (!baseUrl || !paymentId) {
            return "";
        }
        return "".concat(baseUrl, "?pid=").concat(paymentId);
    }, [isMobile, requestInfo.PaymentID, transactionInfo.iFrameUrl, transactionInfo.iFrameUrlMobile]);
    useEffect(function () {
        setIframeSrc(iframeUrl || null);
    }, [iframeUrl]);
    var iframeUrlRef = useRef(iframeUrl);
    useEffect(function () {
        iframeUrlRef.current = iframeUrl;
    }, [iframeUrl]);
    var stopVerificationPolling = useCallback(function () {
        if (retryTimeoutRef.current !== null) {
            window.clearTimeout(retryTimeoutRef.current);
            retryTimeoutRef.current = null;
        }
    }, []);
    var resetHostedFrame = useCallback(function (shouldRefreshProcessorInfo_1) {
        var args_1 = [];
        for (var _i = 1; _i < arguments.length; _i++) {
            args_1[_i - 1] = arguments[_i];
        }
        return __awaiter(void 0, __spreadArray([shouldRefreshProcessorInfo_1], args_1, true), void 0, function (shouldRefreshProcessorInfo, shouldForceNewVantivPayment, refreshedTipAmount) {
            var error_1;
            if (shouldForceNewVantivPayment === void 0) { shouldForceNewVantivPayment = false; }
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        stopVerificationPolling();
                        setPendingPayment(false);
                        setFinalizedPayment(false);
                        setTimeoutActive(false);
                        verificationGateRef.current = createVantivVerificationGate(VERIFY_RETRY_LIMIT);
                        setSubmittedPaymentId(null);
                        setIframeResetKey(function (current) { return current + 1; });
                        setIframeSrc(null);
                        if (resetIframeTimeoutRef.current !== null) {
                            window.clearTimeout(resetIframeTimeoutRef.current);
                            resetIframeTimeoutRef.current = null;
                        }
                        if (!shouldRefreshProcessorInfo) return [3 /*break*/, 4];
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, refreshVantivProcessorInfo({
                                forceNewPayment: shouldForceNewVantivPayment,
                                tipAmount: refreshedTipAmount,
                            })];
                    case 2:
                        _a.sent();
                        return [3 /*break*/, 4];
                    case 3:
                        error_1 = _a.sent();
                        console.error("[VantivHostedPaymentForm] Failed to refresh processor info", error_1);
                        return [3 /*break*/, 4];
                    case 4:
                        resetIframeTimeoutRef.current = window.setTimeout(function () {
                            var nextIframeUrl = iframeUrlRef.current || "";
                            setIframeSrc(nextIframeUrl || null);
                            resetIframeTimeoutRef.current = null;
                        }, 0);
                        return [2 /*return*/];
                }
            });
        });
    }, [refreshVantivProcessorInfo, stopVerificationPolling]);
    var refreshHostedFrameAfterCartUpdate = useCallback(function () { return __awaiter(void 0, void 0, void 0, function () {
        var refreshedTipAmount;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    refreshedTipAmount = getCartTipAmount(currentCart);
                    return [4 /*yield*/, refreshCart()];
                case 1:
                    _a.sent();
                    return [4 /*yield*/, resetHostedFrame(true, true, refreshedTipAmount)];
                case 2:
                    _a.sent();
                    return [2 /*return*/];
            }
        });
    }); }, [currentCart, refreshCart, resetHostedFrame]);
    useEffect(function () {
        if (!currentCart) {
            return;
        }
        // Refreshing processor info generates a new PaymentID. Never do that
        // while the outcome of an already-submitted payment is unresolved.
        if (pendingPayment || submittedPaymentId !== null) {
            return;
        }
        if (previousCartRevisionRef.current === null) {
            previousCartRevisionRef.current = cartRevision;
            void refreshHostedFrameAfterCartUpdate();
            return;
        }
        if (previousCartRevisionRef.current === cartRevision) {
            return;
        }
        previousCartRevisionRef.current = cartRevision;
        void refreshHostedFrameAfterCartUpdate();
    }, [cartRevision, currentCart, pendingPayment, refreshHostedFrameAfterCartUpdate, submittedPaymentId]);
    var abandonZeroAuthPayment = useCallback(function (paymentId) { return __awaiter(void 0, void 0, void 0, function () {
        var error_2;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 2, , 3]);
                    return [4 /*yield*/, axios.post("".concat(window.relativeURI(), "/vantiv/abandon"), {
                            PaymentID: paymentId,
                            ProcessorPaymentID: requestInfo.PaymentID,
                        })];
                case 1:
                    _a.sent();
                    setFinalizedPayment(true);
                    stopVerificationPolling();
                    markPaymentSubmitting(false);
                    reportProcessorError("vantiv", {
                        errorCode: "vantiv_zero_auth_timeout",
                        message: "Card verification took too long. No payment was taken, so you can safely try again.",
                    });
                    void resetHostedFrame(true, true);
                    return [3 /*break*/, 3];
                case 2:
                    error_2 = _a.sent();
                    setFinalizedPayment(true);
                    stopVerificationPolling();
                    markPaymentSubmitting(true);
                    reportProcessorError("vantiv", {
                        errorCode: "vantiv_sale_state_unknown",
                        message: extractApiErrorMessage(error_2, "The payment state could not be confirmed. Please contact the store before trying another payment."),
                    });
                    return [3 /*break*/, 3];
                case 3: return [2 /*return*/];
            }
        });
    }); }, [
        markPaymentSubmitting,
        reportProcessorError,
        requestInfo.PaymentID,
        resetHostedFrame,
        stopVerificationPolling,
    ]);
    var verifyPayment = useCallback(function (requestedPaymentId) { return __awaiter(void 0, void 0, void 0, function () {
        var paymentId, response, error_3, responseErrorCode, errorCode, fallbackErrorMessage, normalizedErrorMessage, paymentIdentityIsUnresolved;
        var _a, _b, _c, _d, _e, _f;
        return __generator(this, function (_g) {
            switch (_g.label) {
                case 0:
                    paymentId = requestedPaymentId !== null && requestedPaymentId !== void 0 ? requestedPaymentId : submittedPaymentId;
                    if (timeoutActive || finalizedPayment || !paymentId) {
                        return [2 /*return*/];
                    }
                    if (!verificationGateRef.current.tryStart()) {
                        // A repeated completion message or timer cannot overlap the active
                        // request. Reaching the attempt limit instead locks the submitted
                        // frame in place for reconciliation.
                        if (verificationGateRef.current.isInProgress()) {
                            return [2 /*return*/];
                        }
                        if (usesZeroAuth) {
                            void abandonZeroAuthPayment(paymentId);
                            return [2 /*return*/];
                        }
                        setFinalizedPayment(true);
                        stopVerificationPolling();
                        reportProcessorError("vantiv", {
                            errorCode: "vantiv_verify_timeout",
                            message: "Your payment result is still pending. Please contact the store before trying another payment.",
                        });
                        return [2 /*return*/];
                    }
                    _g.label = 1;
                case 1:
                    _g.trys.push([1, 3, 4, 5]);
                    return [4 /*yield*/, axios.post("".concat(window.relativeURI(), "/vantiv/verify"), __assign({ headers: {
                                "X-CSRF-TOKEN": (_a = window.session) === null || _a === void 0 ? void 0 : _a.token,
                                credentials: "same-origin",
                                "Content-Type": "application/json",
                                Accept: "application/json",
                                "X-Requested-With": "XMLHttpRequest",
                            }, PaymentID: paymentId, 
                            // Sending both values lets Laravel enforce that the immutable
                            // callback ID still matches the current processor state.
                            ProcessorPaymentID: requestInfo.PaymentID, user_id: checkoutUserId, address_id: currentAddress === null || currentAddress === void 0 ? void 0 : currentAddress.id, comment: checkoutComment, is_curbside_order: isCurbsideOrder, should_send_sms_alerts: shouldSendSmsAlerts, sms_number: smsNumber, has_marketing_opt_in: hasMarketingOptIn }, rewardsSignupPayload))];
                case 2:
                    response = _g.sent();
                    if (response.status === 202 || ((_b = response.data) === null || _b === void 0 ? void 0 : _b.status) === "pending") {
                        // Schedule only after this request resolves; setInterval could
                        // create overlapping verification/finalization requests.
                        retryTimeoutRef.current = window.setTimeout(function () {
                            retryTimeoutRef.current = null;
                            void verifyPaymentRef.current(paymentId);
                        }, VERIFY_INTERVAL_MS);
                    }
                    else if (response.status === 200) {
                        setFinalizedPayment(true);
                        stopVerificationPolling();
                        handleCreditOrderComplete(response.data.order);
                    }
                    return [3 /*break*/, 5];
                case 3:
                    error_3 = _g.sent();
                    responseErrorCode = axios.isAxiosError(error_3)
                        ? (_d = (_c = error_3.response) === null || _c === void 0 ? void 0 : _c.data) === null || _d === void 0 ? void 0 : _d.error_code
                        : undefined;
                    errorCode = typeof responseErrorCode === "number" ? responseErrorCode : null;
                    fallbackErrorMessage = "We couldn't finalize your order. Please call the store at ".concat((_f = (_e = window.session) === null || _e === void 0 ? void 0 : _e.store) === null || _f === void 0 ? void 0 : _f.phone, ".");
                    normalizedErrorMessage = extractApiErrorMessage(error_3, fallbackErrorMessage);
                    if (errorCode === 900) {
                        retryTimeoutRef.current = window.setTimeout(function () {
                            retryTimeoutRef.current = null;
                            void verifyPaymentRef.current(paymentId);
                        }, VERIFY_INTERVAL_MS);
                        return [2 /*return*/];
                    }
                    setFinalizedPayment(true);
                    stopVerificationPolling();
                    paymentIdentityIsUnresolved = errorCode === 904
                        || errorCode === 909
                        || errorCode === 912
                        || errorCode === 914
                        // A network failure after ZeroAuth approval could occur while
                        // CreditSaleToken is in flight. Do not expose a second frame.
                        || (usesZeroAuth && errorCode === null);
                    // Keep checkout submission locked when identity is unresolved. A
                    // new hosted frame could charge the customer a second time.
                    markPaymentSubmitting(paymentIdentityIsUnresolved);
                    if (errorCode === 901) {
                        reportProcessorError("vantiv", { errorCode: "901", message: "Your card was declined. Please try another payment method or contact your bank." });
                    }
                    else if (errorCode === 902) {
                        reportProcessorError("vantiv", { errorCode: "902", message: "Your billing address or zip code was incorrect." });
                    }
                    else if (errorCode === 903) {
                        reportProcessorError("vantiv", { errorCode: "903", message: "Please check the security code (CVV) and try again." });
                    }
                    else {
                        reportProcessorError("vantiv", {
                            errorCode: String(errorCode !== null && errorCode !== void 0 ? errorCode : "vantiv_finalize_error"),
                            message: normalizedErrorMessage,
                        });
                    }
                    if (!paymentIdentityIsUnresolved) {
                        void resetHostedFrame(true, true);
                    }
                    return [3 /*break*/, 5];
                case 4:
                    verificationGateRef.current.finish();
                    return [7 /*endfinally*/];
                case 5: return [2 /*return*/];
            }
        });
    }); }, [
        finalizedPayment,
        handleCreditOrderComplete,
        markPaymentSubmitting,
        reportProcessorError,
        resetHostedFrame,
        checkoutComment,
        checkoutUserId,
        isCurbsideOrder,
        hasMarketingOptIn,
        requestInfo.PaymentID,
        stopVerificationPolling,
        timeoutActive,
        submittedPaymentId,
        shouldSendSmsAlerts,
        smsNumber,
        rewardsSignupPayload,
        usesZeroAuth,
        abandonZeroAuthPayment,
    ]);
    useEffect(function () {
        verifyPaymentRef.current = verifyPayment;
    }, [verifyPayment]);
    useEffect(function () {
        var handleCompletionMessage = function (event) {
            var _a, _b, _c;
            // The completion page is same-origin, but postMessage is accepted
            // only from this exact iframe WindowProxy—not another page or tab.
            if (event.origin !== window.location.origin || event.source !== ((_a = iframeRef.current) === null || _a === void 0 ? void 0 : _a.contentWindow)) {
                return;
            }
            var parsedEvent = parseVantivCompletionEvent(event, window.location.origin, (_b = iframeRef.current) === null || _b === void 0 ? void 0 : _b.contentWindow, String((_c = requestInfo.PaymentID) !== null && _c !== void 0 ? _c : ""));
            if (parsedEvent.reason === "untrusted_event" || parsedEvent.reason === "invalid_event") {
                return;
            }
            if (!parsedEvent.accepted) {
                setFinalizedPayment(true);
                setPendingPayment(true);
                markPaymentSubmitting(true);
                reportProcessorError("vantiv", {
                    errorCode: "vantiv_payment_id_mismatch",
                    message: "This payment could not be matched safely. Please contact the store before trying another payment.",
                });
                return;
            }
            var completion = parsedEvent.completion;
            setSubmittedPaymentId(completion.paymentId);
            setPendingPayment(true);
            markPaymentSubmitting(true);
            void verifyPaymentRef.current(completion.paymentId);
        };
        window.addEventListener("message", handleCompletionMessage);
        return function () { return window.removeEventListener("message", handleCompletionMessage); };
    }, [markPaymentSubmitting, reportProcessorError, requestInfo.PaymentID]);
    var handleFrameLoaded = useCallback(function (event) {
        var _a, _b, _c;
        if (finalizedPayment) {
            return;
        }
        try {
            var currentFrameUrl = (_b = (_a = event.currentTarget.contentWindow) === null || _a === void 0 ? void 0 : _a.location) === null || _b === void 0 ? void 0 : _b.href;
            var timeoutUrl = String((_c = transactionInfo.timeout_url) !== null && _c !== void 0 ? _c : "");
            var normalizedCurrentFrameUrl = String(currentFrameUrl || "").trim();
            var normalizedHostedFormUrl = String(iframeUrl || "").trim();
            if (paymentError !== null && normalizedCurrentFrameUrl && normalizedHostedFormUrl && normalizedCurrentFrameUrl === normalizedHostedFormUrl) {
                clearPaymentError();
            }
            if (currentFrameUrl && timeoutUrl && currentFrameUrl === timeoutUrl) {
                setTimeoutActive(true);
                setFinalizedPayment(true);
                stopVerificationPolling();
                markPaymentSubmitting(false);
                reportProcessorError("vantiv", {
                    errorCode: "vantiv_timeout",
                    message: "For your security this transaction has expired. Please return to your cart and try again.",
                });
                void resetHostedFrame(true);
                return;
            }
            if (normalizedCurrentFrameUrl && normalizedHostedFormUrl && normalizedCurrentFrameUrl !== normalizedHostedFormUrl && paymentError === null) {
                setPendingPayment(true);
                markPaymentSubmitting(true);
            }
        }
        catch (_error) {
            // Cross-origin frame access is expected while hosted payment form is loaded.
        }
    }, [
        clearPaymentError,
        finalizedPayment,
        paymentError,
        iframeUrl,
        markPaymentSubmitting,
        reportProcessorError,
        resetHostedFrame,
        stopVerificationPolling,
        transactionInfo.timeout_url,
    ]);
    useEffect(function () {
        var onResize = function () {
            setIsMobile(window.innerWidth <= 768);
        };
        window.addEventListener("resize", onResize);
        return function () {
            if (resetIframeTimeoutRef.current !== null) {
                window.clearTimeout(resetIframeTimeoutRef.current);
                resetIframeTimeoutRef.current = null;
            }
            window.removeEventListener("resize", onResize);
            stopVerificationPolling();
            markPaymentSubmitting(false);
        };
    }, [markPaymentSubmitting, stopVerificationPolling]);
    if (Number((_c = requestInfo.ResponseCode) !== null && _c !== void 0 ? _c : 0) !== 0) {
        return (React.createElement(Card, { className: "radix-credit-payment-form radix-credit-payment-form--vantiv" },
            React.createElement("p", { className: "radix-credit-payment-description" }, "This store's credit card processor is currently unavailable. Please choose another payment method.")));
    }
    return (React.createElement(Card, { className: "radix-credit-payment-form radix-credit-payment-form--vantiv" },
        React.createElement(PaymentErrorNotice, { error: paymentError }),
        React.createElement("h3", { className: "radix-credit-payment-title" }, "Card Details"),
        React.createElement("p", { className: "radix-credit-payment-description" }, "Transactions may take up to 60 seconds to process after you submit payment. Please do not refresh the page."),
        iframeSrc ? (React.createElement("iframe", { ref: iframeRef, key: iframeResetKey, title: "Vantiv secure payment form", width: "100%", scrolling: "yes", onLoad: handleFrameLoaded, className: "vantivCheckout", src: iframeSrc, frameBorder: "0" })) : null));
};
